const announcementBarControllers = new WeakMap()

const syncAnnouncementSlides = (carousel) => {
  carousel.querySelectorAll('.carousel-item').forEach((slide) => {
    const active = slide.classList.contains('active')
    slide.setAttribute('aria-hidden', active ? 'false' : 'true')
    slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
      if (active) {
        if (control.dataset.announcementTabindex !== undefined) {
          const previous = control.dataset.announcementTabindex
          delete control.dataset.announcementTabindex
          if (previous === '') control.removeAttribute('tabindex')
          else control.setAttribute('tabindex', previous)
        }
      } else {
        if (control.dataset.announcementTabindex === undefined) {
          control.dataset.announcementTabindex = control.getAttribute('tabindex') ?? ''
        }
        control.setAttribute('tabindex', '-1')
      }
    })
  })
}

const initAnnouncementCarousel = (carousel) => {
  if (announcementBarControllers.has(carousel) || typeof bootstrap === 'undefined') return
  const instance = bootstrap.Carousel.getOrCreateInstance(carousel, { interval: false, ride: false })
  instance.pause()
  let announceManualChange = false
  const status = carousel.querySelector('[data-announcement-status]')

  carousel.querySelectorAll('[data-announcement-action]').forEach((control) => {
    control.addEventListener('click', () => {
      announceManualChange = true
      if (control.dataset.announcementAction === 'previous') instance.prev()
      else instance.next()
      instance.pause()
    })
  })

  carousel.addEventListener('slid.bs.carousel', () => {
    syncAnnouncementSlides(carousel)
    if (announceManualChange && status) {
      status.textContent = carousel.querySelector('.carousel-item.active')?.dataset.announcementText || ''
    }
    announceManualChange = false
  })

  syncAnnouncementSlides(carousel)
  announcementBarControllers.set(carousel, instance)
}

const initAnnouncementBars = (root = document) => {
  root.querySelectorAll('[data-announcement-carousel]').forEach(initAnnouncementCarousel)

  root.querySelectorAll('.announcement-bar-sticky').forEach((section) => {
    section.closest('.shopify-section')?.classList.add('sticky-top')
    const navbar = document.querySelector('[id*="__navbar"].sticky-top')
    if (navbar) navbar.style.top = section.clientHeight + 'px'
  })
}

initAnnouncementBars()

document.addEventListener('shopify:section:load', (event) => initAnnouncementBars(event.target))

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('.announcement-bar .carousel-item')
  const carousel = slide?.closest('[data-announcement-carousel]')
  if (!slide || !carousel || typeof bootstrap === 'undefined') return
  initAnnouncementCarousel(carousel)
  const instance = announcementBarControllers.get(carousel)
  instance?.pause()
  instance?.to(Number(slide.dataset.index))
})
